import React from "react";
import Chart from "react-apexcharts";

interface TrafficSourcesProps {
  title?: string;
  data: any;
  type?:
  | "line"
  | "area"
  | "bar"
  | "histogram"
  | "pie"
  | "donut"
  | "radialBar"
  | "scatter"
  | "bubble"
  | "heatmap"
  | "treemap"
  | "boxPlot"
  | "candlestick"
  | "radar"
  | "polarArea"
  | "rangeBar";
  options?: any;
  labels?: string[];
}

const defaultOptions = {
  dataLabels: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      customScale: 0.5,
      donut: {
        size: "50%",
      },
    },
    stroke: {
      colors: undefined,
    },
  },
  colors: ["#2d8bba", "#6ce5e8", "#38b6ff"],
  legend: {
    show: false, // Hide default legend
  },
};

const TrafficSources = ({
  data,
  type = "donut",
  labels = [],
  options,
}: TrafficSourcesProps) => {
  return (
    <div className="traffic-sources-container">
      <div className="custom-pie-chart">
      <Chart
        className= "piechart-dashboard"
        series={data}
        type={type as any}
        height={300}
        options={Object.assign({}, defaultOptions, options, { labels })}
      />
      </div>
      <div className="custom-legend">
        {labels.map((label, index) => (
          <div key={index} className="legend-item legend-item-traffic">
            <span>
              <span
                className="legend-color"
                style={{ backgroundColor: defaultOptions.colors[index] }}
              ></span>
              <span className="legend-label">{label}</span>
            </span>
            <span className="legend-value">{data[index]}h</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrafficSources;
